export default "__VITE_ASSET__e2$ckCho__"